import * as React from 'react';

import { Textarea } from '@components/common';
import { ChevronUpSVG } from '@components/svgs';

interface ChatInputProps {
  inputValue: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSendMessage: () => void;
}

export const ChatInput: React.FC<ChatInputProps> = ({ inputValue, onInputChange, onSendMessage }) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  // Wrapper to convert string to ChangeEvent for AI SDK compatibility
  const handleChange = (value: string) => {
    const syntheticEvent = {
      target: { value },
      currentTarget: { value }
    } as React.ChangeEvent<HTMLTextAreaElement>;
    onInputChange(syntheticEvent);
  };

  return (
    <div className='flex-shrink-0 border-t border-gray-200 p-2'>
      <div className='relative'>
        <Textarea
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyPress}
          placeholder='Ask Great Question...'
          minRows={1}
          maxRows={4}
          className='border-0 pr-10 focus:ring-0'
        />
        <button
          onClick={onSendMessage}
          disabled={!inputValue.trim()}
          className='absolute bottom-2 right-2 flex h-6 w-6 items-center justify-center rounded text-gray-500 hover:text-gray-700 disabled:text-gray-300'
        >
          <ChevronUpSVG className='h-4 w-4' />
        </button>
      </div>
    </div>
  );
};
